import { render, staticRenderFns } from "./c-textmask.vue?vue&type=template&id=16f1a11b&scoped=true"
import script from "./c-textmask.vue?vue&type=script&lang=js"
export * from "./c-textmask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f1a11b",
  null
  
)

export default component.exports